import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import history from '../history';
import {TokenStorage} from "./tokenStorage";

const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER,
    withCredentials: true,
});

AxiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
AxiosInstance.CancelToken = axios.CancelToken;
AxiosInstance.isCancel = axios.isCancel;

AxiosInstance.interceptors.request.use(
    config => {
        config.headers.Authorization = `Bearer ${TokenStorage.getToken()}`;

        return config;
    },
    err => Promise.reject(err)
);

AxiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // Logout user if token refresh didn't work
        // or user is disabled
        if (error.config.url === '/security/token/refresh' && error.response.status === 403) {
            history.push('/logout')

            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    },
);

const refreshToken = (failedRequest) => {
    return AxiosInstance.post('/security/token/refresh', null)
        .then(refreshTokenResponse => {
            if (refreshTokenResponse) {
                TokenStorage.storeToken(refreshTokenResponse.data.token);

                failedRequest.response.config.headers['Authorization'] = `Bearer ${TokenStorage.getToken()}`;
                failedRequest.response.config.headers['Content-Type'] = 'application/json';

                return Promise.resolve();
            }
        })
}

createAuthRefreshInterceptor(AxiosInstance, refreshToken)

export default AxiosInstance;
